// extracted by mini-css-extract-plugin
export default {"gallery":"JToIN4E2","zone":"zone","disabledZone":"disabledZone","imageContainer":"kiUDreEO","image":"HiuZQMkS","imageInnerWrapper":"dHIN9J0b","navigationWrapper":"OAeCY1mZ"};